import { NavLink, Link } from "react-router-dom";
import { ShoppingBag, Menu as MenuIcon, X, UserRound } from "lucide-react";
import { useState } from "react";
import { Logo } from "./Logo";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

const NAV = [
    { to: "/", label: "Home" },
    { to: "/menu", label: "Menu" },
    { to: "/custom-orders", label: "Custom Orders" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export const Header = () => {
    const { count, setIsOpen } = useCart();
    const { user } = useAuth();
    const [open, setOpen] = useState(false);

    return (
        <header
            className="sticky top-0 z-40 backdrop-blur-md"
            style={{ background: "rgba(255, 245, 247, 0.85)", borderBottom: "1px solid var(--sss-border)" }}
            data-testid="site-header"
        >
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-4">
                <Logo size="sm" />

                <nav className="hidden lg:flex items-center gap-7 text-sm uppercase tracking-wider font-medium">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.to === "/"}
                            className={({ isActive }) => `nav-link ${isActive ? "active text-[var(--sss-pink)]" : "text-[var(--sss-text)]"}`}
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <Link
                        to="/my-orders"
                        className="p-2 rounded-full hover:bg-[var(--sss-blush)] transition flex items-center justify-center"
                        aria-label={user ? "My orders" : "Sign in"}
                        data-testid="account-button"
                    >
                        {user?.picture ? (
                            <img src={user.picture} alt="" className="w-[22px] h-[22px] rounded-full" referrerPolicy="no-referrer" />
                        ) : (
                            <UserRound size={22} className="text-[var(--sss-text)]" strokeWidth={1.6} />
                        )}
                    </Link>
                    <button
                        type="button"
                        onClick={() => setIsOpen(true)}
                        className="relative p-2 rounded-full hover:bg-[var(--sss-blush)] transition"
                        aria-label="Open cart"
                        data-testid="cart-icon-button"
                    >
                        <ShoppingBag size={22} className="text-[var(--sss-text)]" strokeWidth={1.6} />
                        {count > 0 && (
                            <span
                                className="absolute -top-0.5 -right-0.5 text-[10px] font-bold text-white rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center"
                                style={{ background: "var(--sss-pink)" }}
                                data-testid="cart-count-badge"
                            >
                                {count}
                            </span>
                        )}
                    </button>
                    <button
                        type="button"
                        className="lg:hidden p-2 rounded-full hover:bg-[var(--sss-blush)]"
                        onClick={() => setOpen((v) => !v)}
                        aria-label="Toggle menu"
                        data-testid="mobile-menu-toggle"
                    >
                        {open ? <X size={22} /> : <MenuIcon size={22} />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-[var(--sss-border)] bg-white" data-testid="mobile-nav">
                    <div className="px-4 py-3 flex flex-col gap-1">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                end={n.to === "/"}
                                onClick={() => setOpen(false)}
                                className={({ isActive }) =>
                                    `px-3 py-2 rounded-lg text-sm font-medium ${isActive ? "bg-[var(--sss-blush)] text-[var(--sss-pink)]" : "text-[var(--sss-text)]"}`
                                }
                                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                {n.label}
                            </NavLink>
                        ))}
                        <NavLink
                            to="/my-orders"
                            onClick={() => setOpen(false)}
                            className={({ isActive }) =>
                                `px-3 py-3 rounded-lg text-sm font-medium ${isActive ? "bg-[var(--sss-blush)] text-[var(--sss-pink)]" : "text-[var(--sss-text)]"}`
                            }
                            data-testid="mobile-nav-my-orders"
                        >
                            {user ? "My Orders" : "Sign In / My Orders"}
                        </NavLink>
                    </div>
                </div>
            )}
        </header>
    );
};
